// extracted by mini-css-extract-plugin
export default {"tandc":"returns_tandc__w1W-Q","container":"returns_container__KZB43","policyContent":"returns_policyContent__QHTT8"};